<template>
    <div class="row g-3 mb-3">
        <div v-for="balise in balises" :key="balise.id" class="col-12 col-sm-6 col-lg-4">
            <BaliseCardDisplay :balise="balise" />
        </div>
    </div>
</template>

<script>
import BaliseCardDisplay from '../components/BaliseCardDisplay.vue'

export default {
    name: 'BalisesListCard',
    components: {
        BaliseCardDisplay
    },
    props: {
        balises: {
            type: Array,
            default: () => []
        }
    }
}
</script>